import { Action } from '@ngrx/store';
import { LicenseDataInterface } from 'app/site-settings/models/license-data.model';

import { SiteSettingActionType } from './site-setings-action-type.enum';

export class LoadSiteLicense implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteLicense;

  public readonly payload: any = undefined;
}

export class LoadSiteLicenseCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteLicenseCompleted;

  constructor(public readonly payload: LicenseDataInterface) { }
}

export class LoadSiteLicenseFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.LoadSiteLicenseFailed;

  constructor(public readonly payload: string) { }
}
export class UpdateSiteLicense implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteLicense;

  constructor(public readonly payload: string) { }
}

export class UpdateSiteLicenseCompleted implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteLicenseCompleted;

  constructor(public readonly payload: string) { }
}

export class UpdateSiteLicenseFailed implements Action {
  public readonly type: SiteSettingActionType = SiteSettingActionType.UpdateSiteLicenseFailed;

  constructor(public readonly payload: string) { }
}
